import type { ReleasePhaseInternal, ReleaseStatusInternal } from '@gonfalon/openapi/types';

export const guardedReleasePhaseActiveStatuses: ReleaseStatusInternal[] = [
  'in_progress',
  'monitoring_regressed',
  'monitoring_stopped',
];

export function isGuardedReleasePhaseActive(release: ReleasePhaseInternal): boolean {
  return guardedReleasePhaseActiveStatuses.includes(release.status);
}
